"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { InfoNewOptionsModel } from "@/models/paymentModels/InfoNewOptions.model";
import { PaymentBrowsersModel, PaymentComputerConfigModel, PaymentCountriesModel, PaymentLanguagesModel, PaymentOperatingOsModel, PaymentOperatingUaModel, PaymentResolutionModel, PaymentTimezonesModel } from "@/models/paymentModels/paymentNewComputerConfig.model";
import { PaymentSelectedModel } from "@/models/paymentModels/paymentNewDefault.model";
import { CategoryInfoModel } from "@/models/paymentModels/SelectNewOptions.model";
import API from "@ym-framework/api-utils";
import _ from "lodash";
export class CategorieIds {
  constructor() {
    this.types = null;
    this.regions = null;
    this.areas = null;
    this.remotes = null;
    this.models = null;
    this.categorys = null;
  }
}
export class DataSeriveNewProduct {
  constructor() {
    this._datas = /* @__PURE__ */ new Map();
    this._relations = /* @__PURE__ */ new Map();
    this._syncDataSession = null;
    this._syncReady = false;
  }
  set ready(data) {
    this._syncReady = data;
  }
  get ready() {
    return this._syncReady;
  }
  clear() {
    this._datas = /* @__PURE__ */ new Map();
    this._relations = /* @__PURE__ */ new Map();
    this._syncDataSession = null;
  }
  init(searchParams) {
    return __async(this, null, function* () {
      if (this._syncDataSession === null) {
        this._syncDataSession = new Promise((resolve, reject) => __async(this, null, function* () {
          try {
            this._syncReady = false;
            let response = yield API.get(`api://base.auth/api/v8/payment/virtualdesktop/region/categories`, {
              params: (() => {
                if (searchParams) {
                  return searchParams;
                }
                return null;
              })()
            });
            for (const _dataType in response.data) {
              if (_dataType === "model") {
                continue;
              }
              const _dataTypeName = `${_dataType}`;
              if (!this._datas.has(_dataTypeName)) {
                this._datas.set(_dataTypeName, /* @__PURE__ */ new Map());
              }
              for (const _dataItem of _.get(response.data, _dataType)) {
                this._datas.get(_dataTypeName).set(_dataItem.id, _dataItem);
                if (_dataItem.parent_type === null) {
                  continue;
                }
                const _relationsName = `${_dataItem.parent_type}s`;
                if (!this._relations.has(_relationsName)) {
                  this._relations.set(_relationsName, /* @__PURE__ */ new Map());
                }
                if (!this._relations.get(_relationsName).has(_dataItem.parent_id)) {
                  this._relations.get(_relationsName).set(_dataItem.parent_id, /* @__PURE__ */ new Set());
                }
                this._relations.get(_relationsName).get(_dataItem.parent_id).add({
                  id: _dataItem.id,
                  dataType: _dataTypeName
                });
              }
            }
            this._syncReady = true;
            resolve(this);
          } catch (error) {
            console.log(error);
            reject(error);
          }
        }));
      }
      return this._syncDataSession;
    });
  }
  getDatas(dataType) {
    return this._datas.get(dataType);
  }
  getData(dataType, id) {
    return this._datas.get(dataType).get(id);
  }
  getRelationDatas(dataType, id) {
    const _that = this;
    return new Set(function* () {
      if (!_that._relations.has(dataType)) {
        return;
      }
      if (!_that._relations.get(dataType).has(id)) {
        return;
      }
      for (const _relationItem of _that._relations.get(dataType).get(id)) {
        yield _that.getData(_relationItem.dataType, _relationItem.id);
      }
    }());
  }
}
export class ConfigDataNewProduct {
  constructor() {
    this._datas = new PaymentComputerConfigModel();
    this._syncDataSession = null;
    this._syncReady = false;
  }
  clear() {
    this._syncDataSession = null;
  }
  init() {
    return __async(this, null, function* () {
      if (this._syncDataSession === null) {
        this._syncDataSession = new Promise((resolve, reject) => __async(this, null, function* () {
          try {
            this._syncReady = false;
            let response = yield API.get(`api://base.auth/api/v8/payment/virtualdesktop/region/common`);
            this._datas = response.data;
            this._syncReady = true;
            resolve(this);
          } catch (error) {
            console.log(error);
            reject(error);
          }
        }));
      }
      return this._syncDataSession;
    });
  }
  get ready() {
    return this._syncReady;
  }
  get data() {
    return this._datas;
  }
}
export class PaymentController {
  constructor() {
    this.productDatas = new DataSeriveNewProduct();
    //区域数据集
    this.categoryDatas = new Array();
    //商品数据集
    this.goodsDatas = new Array();
    //时长
    this.configDatas = new ConfigDataNewProduct();
    //环境数据集
    this.categorieids = new CategorieIds();
    this.selected = new PaymentSelectedModel();
    //备选列表
    this.selectedTypes = [];
    this.selectedRegions = [];
    this.selectedAreas = [];
    this.selectedRemotes = [];
    this.selectedModels = [];
  }
  init() {
    return __async(this, null, function* () {
      yield this.productDatas.init(this.selected.searchParams);
      yield this.configDatas.init();
    });
  }
  search() {
    return __async(this, null, function* () {
      this.productDatas.clear();
      this.categorieids = new CategorieIds();
      yield this.init();
      yield this.changeTypes();
    });
  }
  changeTypes() {
    return __async(this, null, function* () {
      this.selected.types = null;
      this.selectedTypes = _.sortBy(Array.from(this.productDatas.getDatas("types").values()), (o) => {
        return o.sort;
      });
      for (const group of this.selectedTypes) {
        if (this.categorieids.types !== null) {
          if (this.categorieids.types === group.id) {
            this.selected.types = group;
            break;
          }
        } else {
          if (group.marks.is("DEFAULT_SELECTED")) {
            this.selected.types = group;
            break;
          }
        }
      }
      if (this.selected.types === null) {
        this.selected.types = this.selectedTypes[0];
      }
      yield this.changeRegions(this.selected.types.id);
    });
  }
  changeRegions(id) {
    return __async(this, null, function* () {
      const _regions = this.productDatas.getRelationDatas("types", id);
      this.selected.regions = null;
      this.selectedRegions = [];
      if (_regions && _regions.size > 0) {
        this.selectedRegions = _.sortBy(Array.from(_regions), (o) => {
          return o.sort;
        });
        for (const region of this.selectedRegions) {
          if (this.categorieids.regions !== null) {
            if (this.categorieids.regions === region.id) {
              this.selected.regions = region;
              break;
            }
          } else {
            if (region.marks.is("DEFAULT_SELECTED")) {
              this.selected.regions = region;
              break;
            }
          }
        }
        if (this.selected.regions === null) {
          this.selected.regions = this.selectedRegions[0];
        }
        id = this.selected.regions.id;
      }
      yield this.changeAreas(id);
    });
  }
  changeAreas(id) {
    return __async(this, null, function* () {
      const _areas = this.productDatas.getRelationDatas("regions", id);
      this.selected.areas = null;
      this.selectedAreas = [];
      if (_areas && _areas.size > 0) {
        this.selectedAreas = _.sortBy(Array.from(
          _areas
        ), (o) => {
          return o.sort;
        });
        for (const areas of this.selectedAreas) {
          if (this.categorieids.areas !== null) {
            if (this.categorieids.areas === areas.id) {
              this.selected.areas = areas;
              break;
            }
          } else {
            if (areas.marks.is("DEFAULT_SELECTED")) {
              this.selected.areas = areas;
              break;
            }
          }
        }
        if (this.selected.areas === null) {
          this.selected.areas = this.selectedAreas[0];
        }
        id = this.selected.areas.id;
      }
      yield this.changeRemotes(id);
    });
  }
  changeRemotes(id) {
    return __async(this, null, function* () {
      const _remotes = this.productDatas.getRelationDatas("areas", id);
      this.selected.remotes = null;
      this.selectedRemotes = [];
      if (_remotes && _remotes.size > 0) {
        this.selectedRemotes = _.sortBy(Array.from(
          _remotes
        ), (o) => {
          return o.sort;
        });
        for (const remotes of this.selectedRemotes) {
          if (this.categorieids.remotes !== null) {
            if (this.categorieids.remotes === remotes.id) {
              this.selected.remotes = remotes;
              break;
            }
          } else {
            if (remotes.marks.is("DEFAULT_SELECTED")) {
              this.selected.remotes = remotes;
              break;
            }
          }
        }
        if (this.selected.remotes === null) {
          this.selected.remotes = this.selectedRemotes[0];
        }
        id = this.selected.remotes.id;
      }
      yield this.changeModels(id);
    });
  }
  changeModels(id) {
    return __async(this, null, function* () {
      const _models = this.productDatas.getRelationDatas("remotes", id);
      this.selected.models = null;
      this.selectedModels = [];
      if (_models && _models.size > 0) {
        this.selectedModels = _.sortBy(Array.from(
          _models
        ), (o) => {
          return o.sort;
        });
        for (const models of this.selectedModels) {
          if (this.categorieids.models !== null) {
            if (this.categorieids.models === models.id) {
              this.selected.models = models;
              break;
            }
          } else {
            if (models.marks.is("DEFAULT_SELECTED")) {
              this.selected.models = models;
              break;
            }
          }
        }
        if (this.selected.models === null) {
          this.selected.models = this.selectedModels[0];
        }
      }
      yield this.changeCategorys();
    });
  }
  changeCategorys() {
    return __async(this, null, function* () {
      try {
        this.selected.categorysLoading = true;
        let ip_ids = [];
        if (this.selected.types) {
          ip_ids.push(this.selected.types.id);
        }
        ;
        if (this.selected.regions) {
          ip_ids.push(this.selected.regions.id);
        }
        ;
        if (this.selected.areas) {
          ip_ids.push(this.selected.areas.id);
        }
        ;
        if (this.selected.remotes) {
          ip_ids.push(this.selected.remotes.id);
        }
        ;
        if (this.selected.models) {
          ip_ids.push(this.selected.models.id);
        }
        ;
        let response = yield API.get(`api://base.auth/api/v8/payment/virtualdesktop/regions`, {
          params: __spreadValues(__spreadValues({}, (() => {
            if (ip_ids.length > 0) {
              return { ip_region_ids: ip_ids.join(",") };
            }
            return {};
          })()), this.selected.searchParams)
        });
        if (response.data.datas && response.data.datas.length > 0) {
          this.selected.categorys = null;
          this.categoryDatas = [];
          this.categoryDatas = _.sortBy(response.data.datas, (o) => {
            return o.sort;
          });
          if (this.categoryDatas && this.categoryDatas.length > 0) {
            for (const category of this.categoryDatas) {
              this.selected.paymentShowPaypal = category.payment.includes("paypal");
              if (this.categorieids.categorys !== null) {
                if (this.categorieids.categorys === category.id) {
                  this.selected.categorys = category;
                  break;
                }
              } else {
                if (category.marks.is("DEFAULT_SELECTED")) {
                  this.selected.categorys = category;
                  break;
                }
              }
            }
            if (this.selected.categorys === null) {
              this.selected.categorys = response.data.datas[0];
            }
          }
        }
        yield this.changeGoods();
        yield this.changeConfigs();
      } catch (error) {
        throw error;
      } finally {
        this.selected.categorysLoading = false;
      }
    });
  }
  //续费获取goods
  renewSearch(ids) {
    return __async(this, null, function* () {
      try {
        if (ids.length <= 0) {
          return;
        }
        this.productDatas.ready = false;
        this.selected.categorysLoading = true;
        this.selected.paymentQuantity = ids.length;
        this.selected.paymentGoldbeanUsed = 0;
        this.selected.goods = null;
        this.goodsDatas = [];
        let response = yield API.post(`api://base.auth/api/v7/payment/virtualdesktop/options/batchrenew`, { vd_ids: ids });
        this.selected.paymentShowPaypal = response.data.payment.includes("paypal");
        this.selected.paymentShowAutoRenew = response.data.show_auto_renew;
        this.selected.paymentAutoRenew = response.data.auto_renew;
        this.selected.categorys = new InfoNewOptionsModel();
        this.selected.categorys.payment = response.data.payment;
        this.selected.categorys.payments = response.data.payments;
        this.goodsDatas = response.data.goods_spec;
        if (this.selected.goods === null) {
          this.selected.goods = this.goodsDatas[0];
        }
      } catch (error) {
        throw error;
      } finally {
        this.productDatas.ready = true;
        this.selected.categorysLoading = false;
      }
    });
  }
  changeGoods() {
    return __async(this, null, function* () {
      var _a, _b, _c;
      this.selected.paymentQuantity = 1;
      this.selected.paymentGoldbeanUsed = 0;
      this.selected.paymentShowAutoRenew = this.selected.categorys.show_auto_renew;
      this.selected.goods = null;
      this.goodsDatas = [];
      if (((_a = this.selected.categorys) == null ? void 0 : _a.goods_spec) && ((_b = this.selected.categorys) == null ? void 0 : _b.goods_spec.length) > 0) {
        this.goodsDatas = (_c = this.selected.categorys) == null ? void 0 : _c.goods_spec;
        for (const region of this.goodsDatas) {
          if (region.marks && region.marks.is("DEFAULT_SELECTED")) {
            this.selected.goods = region;
            break;
          }
        }
        if (this.selected.goods === null) {
          this.selected.goods = this.goodsDatas[0];
        }
      }
    });
  }
  //环境
  changeConfigs() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e;
      this.selected.configCountrie = new PaymentCountriesModel();
      this.selected.configOs = new PaymentOperatingOsModel();
      this.selected.configUseragent = new PaymentOperatingUaModel();
      this.selected.configSystemUnify = false;
      this.selected.configSystemWindows = "";
      this.selected.configSystemWindowsUa = null;
      this.selected.configSystemMac = "";
      this.selected.configSystemMacUa = null;
      this.selected.configSystemAndroid = "";
      this.selected.configSystemAndroidUa = null;
      this.selected.configSystemLinux = "";
      this.selected.configSystemLinuxUa = null;
      this.selected.configSystemUnifyOs = null;
      this.selected.configBrowser = new PaymentBrowsersModel();
      this.selected.configAutoResolution = true;
      this.selected.configResolution = new PaymentResolutionModel();
      this.selected.configShowAutoResolution = true;
      this.selected.configTimezone = new PaymentTimezonesModel();
      this.selected.configAutoTimezone = false;
      this.selected.configShowAutoTimezone = false;
      this.selected.configLanguage = new PaymentLanguagesModel();
      const configCountrie = _.find(this.configDatas.data.countries, { id: (_a = this.selected.categorys) == null ? void 0 : _a.default_selection.country_id });
      if (configCountrie) {
        this.selected.configCountrie = configCountrie;
        this.selected.configBrowser = configCountrie.browsers[0];
      }
      this.selected.configOs = this.configDatas.data.os;
      this.selected.configUseragent = this.configDatas.data.useragent;
      this.selected.configSystemWindows = this.configDatas.data.os.windows[0];
      this.selected.configSystemWindowsUa = this.configDatas.data.useragent[this.selected.configSystemWindows][0];
      this.selected.configSystemMac = this.configDatas.data.os.mac[0];
      this.selected.configSystemMacUa = this.configDatas.data.useragent[this.selected.configSystemMac][0];
      this.selected.configSystemAndroid = this.configDatas.data.os.android[0];
      this.selected.configSystemAndroidUa = this.configDatas.data.useragent[this.selected.configSystemAndroid][0];
      this.selected.configSystemLinux = this.configDatas.data.os.linux[0];
      this.selected.configSystemLinuxUa = this.configDatas.data.useragent[this.selected.configSystemLinux][0];
      const configTimezone = _.find(this.configDatas.data.timezones, { id: (_b = this.selected.categorys) == null ? void 0 : _b.default_selection.timezone_id });
      if (configTimezone) {
        this.selected.configTimezone = configTimezone;
      }
      this.selected.configAutoTimezone = ((_c = this.selected.categorys) == null ? void 0 : _c.show_auto_timezone) || false;
      this.selected.paymentShowAutoRenew = ((_d = this.selected.categorys) == null ? void 0 : _d.show_auto_renew) || false;
      const configLanguage = _.find(this.configDatas.data.languages, { id: (_e = this.selected.categorys) == null ? void 0 : _e.default_selection.language_id });
      if (configLanguage) {
        this.selected.configLanguage = configLanguage;
      }
    });
  }
  selectCategorieByIds(categorieIds) {
    return __async(this, null, function* () {
      this.categorieids = categorieIds;
      yield this.init();
      this.changeTypes();
    });
  }
  findByIdAll(id) {
    let _categoryInfo = new CategoryInfoModel();
    let _id = id;
    if (this.productDatas.getDatas("models") && this.productDatas.getDatas("models").has(_id)) {
      _categoryInfo.models = this.productDatas.getDatas("models").get(_id);
      _id = _categoryInfo.models.parent_id;
    }
    if (this.productDatas.getDatas("remotes") && this.productDatas.getDatas("remotes").has(_id)) {
      _categoryInfo.remotes = this.productDatas.getDatas("remotes").get(_id);
      _id = _categoryInfo.remotes.parent_id;
    }
    if (this.productDatas.getDatas("areas") && this.productDatas.getDatas("areas").has(_id)) {
      _categoryInfo.areas = this.productDatas.getDatas("areas").get(_id);
      _id = _categoryInfo.areas.parent_id;
    }
    if (this.productDatas.getDatas("regions") && this.productDatas.getDatas("regions").has(_id)) {
      _categoryInfo.regions = this.productDatas.getDatas("regions").get(_id);
      _id = _categoryInfo.regions.parent_id;
    }
    if (this.productDatas.getDatas("types") && this.productDatas.getDatas("types").has(_id)) {
      _categoryInfo.types = this.productDatas.getDatas("types").get(_id);
    }
    return _categoryInfo;
  }
  findById(id) {
    if (this.productDatas.getDatas("models").has(id)) {
      return this.productDatas.getDatas("models").get(id);
    }
    if (this.productDatas.getDatas("remotes").has(id)) {
      return this.productDatas.getDatas("remotes").get(id);
    }
    if (this.productDatas.getDatas("areas").has(id)) {
      return this.productDatas.getDatas("areas").get(id);
    }
    if (this.productDatas.getDatas("regions").has(id)) {
      return this.productDatas.getDatas("regions").get(id);
    }
    if (this.productDatas.getDatas("types").has(id)) {
      return this.productDatas.getDatas("types").get(id);
    }
    return null;
  }
}
